import { Box, Divider, Flex, Image, Link, Text } from '@chakra-ui/react';
import { format, isValid } from 'date-fns';
import iconsPng from '@/assets/img/png/icons';
import svgFiles from '@/assets/svg/svgFiles';
import { background, text } from '@/theme/colors/palettes';
import WeeklyReportDashboardButton from './WeeklyReportDashboardButton';

interface Props {
  variant?: 'success' | 'already-submitted';
  submittedAt?: string | null;
}

const WeeklyReportConfirmation = ({ variant = 'already-submitted', submittedAt }: Props) => {
  const isSuccess = variant === 'success';
  const submittedDate = submittedAt ? new Date(submittedAt) : undefined;

  return (
    <Box textAlign="center" role="status">
      <Image
        src={isSuccess ? iconsPng.handshake : iconsPng.okHand}
        alt=""
        boxSize="100px"
        objectFit="contain"
        mx="auto"
      />
      <Text as="h1" variant="loraExtraSmallTitle" color={text.mediumBlue} mt={10}>
        {isSuccess
          ? 'You have successfully added a weekly report, bravo!'
          : 'You have already added a weekly report, bravo!'}
      </Text>
      {!isSuccess && (
        <Text color={text.mediumGray} fontSize="16px" fontWeight={600} mt={2}>
          {submittedDate && isValid(submittedDate)
            ? `You added your report at ${format(submittedDate, 'h:mma')} on ${format(submittedDate, 'EEEE')}.`
            : 'Your weekly report has already been submitted.'}
        </Text>
      )}

      <Divider borderColor={background.separatorBlue} opacity={1} my={10} />

      <Text as="h2" color={text.mediumBlue} fontSize="20px" fontWeight={700}>
        Forgot to add a contact?
      </Text>
      <Text color={text.mediumBlue} fontSize="18px" fontWeight={500} lineHeight="22px" mt={4}>
        You can log in to the MyOmnia web or mobile app and add backdated contacts. However, backdated contacts must be
        added one at a time.
      </Text>

      <WeeklyReportDashboardButton mt={8} />
      <Flex w="370px" maxW="100%" mx="auto" mt={5} gap={5} justify="center">
        <Link href="https://apps.apple.com/app/6748853118" isExternal flex={1} minW={0}>
          <Image src={svgFiles.appStoreBadge} alt="Download on the App Store" w="100%" />
        </Link>
        <Link href="https://play.google.com/store/apps/details?id=com.myomnia.app" isExternal flex={1} minW={0}>
          <Image src={svgFiles.playStoreBadge} alt="Get it on Google Play" w="100%" />
        </Link>
      </Flex>
    </Box>
  );
};

export default WeeklyReportConfirmation;
